import { render, staticRenderFns } from "./DeviceDetailCommonTable.vue?vue&type=template&id=bcfa3c12&"
import script from "./DeviceDetailCommonTable.vue?vue&type=script&lang=js&"
export * from "./DeviceDetailCommonTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports